import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(duration);
dayjs.extend(relativeTime);
export const getMinutesAndHours = (totalMinutes) => {
    const val = dayjs.duration(totalMinutes, 'minutes');
    const displayString = [];
    const formattedMinutes = val.format('m');
    if (val.asHours() >= 1) {
        const formattedHours = Math.floor(val.asHours());
        const hourLabel = formattedHours === 1 ? 'hour' : 'hours';
        displayString.push(`${formattedHours} ${hourLabel}`);
    }
    if (formattedMinutes !== '0') {
        const minutesLabel = formattedMinutes === '1' ? 'minute' : 'minutes';
        displayString.push(`${formattedMinutes} ${minutesLabel}`);
    }
    return displayString.join(' ');
};
